var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTwitterMobile = function SvgIconTwitterMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M7.71 10.524.862 1.814h5.423l4.226 5.384 4.514-5.359h2.986l-6.057 7.198 7.182 9.149h-5.406l-4.575-5.822L4.27 18.17H1.268l6.441-7.645Zm6.81 6.048L4.187 3.429h1.309l10.318 13.143H14.52Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTwitterMobile;